<template>
  <el-card>
    <el-form size="default">
      <h3>Filters</h3>
      <el-row :gutter="10">
        <el-col :span="12" :xs="24">
          <el-form-item>
            <el-input
              v-model="filter.title"
              type="text"
              placeholder="List name.."
              clearable
              @keyup.enter="update"
              @clear="update"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <hr />
      <el-row :gutter="10">
        <el-col :span="6" :xs="12">
          <el-form-item>
            <el-button
              type="success"
              :icon="isDesktop ? 'PlusElementIcon' : ''"
              round
              size="small"
              @click="create"
            >
              Create a NEW list
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6" :xs="12">
          <el-form-item>
            <el-button
              type="primary"
              :disabled="disabled"
              :icon="isDesktop ? 'EditElementIcon' : ''"
              round
              size="small"
              @click="add"
            >
              Add Ips
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6" :xs="12">
          <el-form-item>
            <el-button
              type="warning"
              :disabled="disabled"
              :icon="isDesktop ? 'CloseElementIcon' : ''"
              round
              size="small"
              @click="remove"
            >
              Remove IPs
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6" :xs="12">
          <el-form-item>
            <el-popconfirm
              confirm-button-text="OK"
              cancel-button-text="No, Thanks"
              confirm-button-type="danger"
              icon="InfoFilledElementIcon"
              icon-color="red"
              :title="destroyTitle"
              @confirm="destroy"
            >
              <template #reference>
                <el-button
                  type="danger"
                  :disabled="disabled"
                  :icon="isDesktop ? 'FilesElementIcon' : ''"
                  round
                  size="small"
                >
                  Archive
                </el-button>
              </template>
            </el-popconfirm>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script lang="ts">
import { defineComponent, ref, computed, reactive } from 'vue'
import { IIPListFilter } from '@/api/ip_lists'
import useResize from '@/hooks/useResize'
import { useIPListsStore } from '@/apps/traforama/store/ipLists'

export default defineComponent({
  name: 'FilterPanel',
  components: {},
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const ipListsStore = useIPListsStore()
    const { isDesktop } = useResize()

    const filter = ref({ ...props.modelValue })
    const update = () => {
      context.emit('update:modelValue', { ...filter.value })
      context.emit('update', {})
    }

    const reset = () => {
      context.emit('update:modelValue', {})
      context.emit('update', {})
    }
    const create = () => {
      context.emit('create')
    }
    const destroy = () => {
      context.emit('destroy')
    }
    const add = () => {
      context.emit('add')
    }
    const remove = () => {
      context.emit('remove')
    }
    const disabled = computed(() => {
      return Object.keys(ipListsStore.selected).length < 1
    })

    const destroyTitle = computed(() => {
      const campaigns = Object.values(ipListsStore.selected).flatMap(
        ({ attributes: { campaigns } }) => campaigns
      )
      if (campaigns.length) {
        return `You use this lists on the campaigns: ${campaigns.join(', ')}.\n
        Are you sure you want to archive the lists?\n
        After archivation this lists will be removed from the campaigns as a block or white list.\n
        You can't undo this action.`
      }
      return "Are you sure you want to archive the lists? You can't undo this action"
    })

    return {
      update,
      reset,
      filter,
      create,
      destroy,
      add,
      remove,
      isDesktop,
      disabled,
      destroyTitle
    }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-card__body) {
  padding: 0px 5px;
}

.el-form-item {
  width: 90%;
  text-align: center;
  margin-bottom: 2px;
}

h3 {
  margin: 2px 8px 5px 8px;
  padding-top: 5px;
}

:deep(.selected-checkbox .el-form-item__label) {
  padding-right: 5px;
}

:deep(.el-collapse-item__content) {
  padding-bottom: 5px;
}

:deep(.el-form-item--small .el-form-item__label) {
  padding: 0;
}

:deep(.el-form-item--small.el-form-item) {
  margin-bottom: 0;
}
</style>
